import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'check-date-validity-pipe'})
export class CheckDateValidityPipe implements PipeTransform {
  transform(startDate: any,endDate:any,toDay:any) {
    // accepted date format 2021-03-21(yyyy-mm-dd) format    
    var d1 = startDate.split("-");
    var d2 = endDate.split("-");
    var c = toDay.split("-");    
    var from = new Date(d1[0], parseInt(d1[1])-1, d1[2]);  // -1 because months are from 0 to 11
    var to   = new Date(d2[0], parseInt(d2[1])-1, d2[2]);
    var check = new Date(c[0], parseInt(c[1])-1, c[2]);   
    return check >= from && check <= to ;
    }  
  }